module.exports = __webpack_public_path__ + "static/media/icon_document2-bofa.57c7d3c9.svg";